import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import adsbApi from '../adsb';
import AuthSlice from './auth';
import geoserverApi from '../geoserver';
import metconsoleApi from '../metconsole';
import keycloakApi from '../keycloak';
import dtnApi from '../dtn/api';

export const store = configureStore({
  reducer: {
    [geoserverApi.reducerPath]: geoserverApi.reducer,
    [metconsoleApi.reducerPath]: metconsoleApi.reducer,
    [keycloakApi.reducerPath]: keycloakApi.reducer,
    [adsbApi.reducerPath]: adsbApi.reducer,
    [dtnApi.reducerPath]: dtnApi.reducer,
    auth: AuthSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
    .concat(geoserverApi.middleware)
    .concat(metconsoleApi.middleware)
    .concat(keycloakApi.middleware)
    .concat(adsbApi.middleware)
    .concat(dtnApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
